module.exports = __webpack_public_path__ + "img/Booking-Details.8487ee9e.jpg";